import { useEffect, useState } from "react";
import { useRequest } from "../api/useRequest";
import { usePushErrorLog } from "./usePushErrorLog";
import { HotelLocation } from "../types/HotelLocation";
import { getHotelLocation } from "../api/actions/getHotelLocation";

export function useHotelLocation(locationCode?: string, locationType?: string) {
  const [hotelLocation, setHotelLocation] = useState<HotelLocation>();
  const request = useRequest();
  const logError = usePushErrorLog();

  useEffect(() => {
    if (locationCode && locationType) {
      request<HotelLocation>(getHotelLocation(locationCode, locationType))
        .then(setHotelLocation)
        .catch((error) => {
          // TODO: what if we don't have location
          logError(error, {
            customMessage: `Error during fetching hotel location: ${{
              locationCode,
              locationType,
            }}.`,
          });
        });
    }
  }, [locationCode, locationType, setHotelLocation, request, logError]);

  return hotelLocation;
}
